<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Copy Offer Division</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <br />
      <v-row dense>
        <v-col cols="12" sm="5" md="5" style="text-align: right;">
          <v-autocomplete rounded dense required item-value="id" v-model="from_ay" :items="ay_list" item-text="ay"
            label="From Academic Year" outlined @change="getDeatils()" />
        </v-col>
        <v-col cols="12" sm="2" md="2" style="text-align: center;">
          <v-btn text color="#0f2027" :loading="copy_btn_load">
            <v-icon large color="#0f2027">mdi-arrow-right-bold-circle</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="5" md="5" style="text-align: left;">
          <v-autocomplete rounded dense required v-model="to_ay" item-value="id" :items="ay_list" item-text="ay"
            label="To Academic Year" outlined />
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-btn v-if="to_ay" class="button" :loading="loading" @click="copyDivisionDetails()">Copy Division
          Details</v-btn>
      </v-row>
    </v-card>
    <v-card class="box" v-if="std_list!=''">
      <v-simple-table dense class="elevation-1" fixed-header height="500px">
        <tr>
          <th>
            <center>Sr. No.</center>
          </th>
          <th>
            <center>Standard</center>
          </th>
          <th>
            <center>Division Details</center>
          </th>
        </tr>
        <tbody>
          <tr v-for="(l,index) in std_list" :key="l.id">
            <td>{{index + 1}}</td>
            <td>{{l.std}}</td>
            <td>
              <!-- {{l.div_off_list}} -->
            <th flat class="pt-1 mt-1" v-for="(d,index1) in l.div_off_list" :key="index1">
              Division : {{d.division}} <br>
              Capacity : {{d.capacity}} <br>
              stream : {{d.stream}}
            </th>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

import axios from "axios";
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    ay_list: null,
    // extraBreadcrumbItems: [
    

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    to_ay: null,
    from_ay: null,
    search: "",
    copy_btn_load: false,
    standard_list: [],
    singleSelect: false,
    selectedTasks: [],
    standard: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    loader: false,
    std_list: [],
    loading: false,
  }),

  methods: {
    copyDivisionDetails() {
      const data = {
        ay: this.from_ay,
        to_ay: this.to_ay,
      };
      this.loading = true;
      axios
        .post("/Admission/copyStdDivisionDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4CAF50", "Copied Successfully...");
            this.onLoad();
            this.loading = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.loading = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.from_ay = null;
          this.to_ay = null;
          this.std_list = [];
        });
    },
    getDeatils() {
      const data = {
        ay: this.from_ay,
      };
      this.loader = true;
      axios
        .post("/Admission/getStdDivisionDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.std_list = res.data.std_list;
            this.loader = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.loader = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.loader = false;
        })
        .finally(() => {});
    },
    onLoad() {
      axios
        .post("/Examination/getInitialData")
        .then((res) => {
          this.ay_list = res.data.ay_list;
          this.standard_list = res.data.standard_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.copy_offer_btn_load = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
};
</script>
<style scoped>
.scroll {
  overflow-x: scroll;
}
.text-color {
  font-weight: bold;
  color: red;
  font-size: small;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
.mytable2 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.dt-button {
  font-size: small;
  font-weight: bold;
}
.dt-button.buttons-print::before {
  content: "\F42A";
  margin-right: 8px;
  margin-top: 8px;
  font-size: small;
}
.dt-button.buttons-excel::before {
  content: "\F21B";
  margin-right: 8px;
  margin-top: 8px;
  font-size: small;
}
.dt-button.buttons-csv::before {
  content: "\FEC2";
  margin-right: 8px;
  margin-top: 8px;
  font-size: small;
}
button.dt-button:hover:not(.disabled),
div.dt-button:hover:not(.disabled),
a.dt-button:hover:not(.disabled) {
  border-color: #ff9800;
  color: #ff9800;
}
.dataTables_wrapper .dataTables_filter input[type="search"] {
  border-radius: 2px;
  border: 1px solid #cdcdcd;
  cursor: auto;
  white-space: nowrap !important;
}
</style>
